import { useMutation } from "react-query";
import useAuth from "./useAuth";

/**
 * Custom hook to fetch activities for a specific case using react-query.
 * @hook
 * @author Sanjay
 */

export default function useErrorLogs(caseId?: string) {
  const { request } = useAuth();

  const { mutateAsync: saveErrorLogs, isLoading: isLogsLoading } = useMutation(
    "/error-logs",
    (error) =>
      request
        .post(`/error-logs`, error)
        .then((response) => response?.data as any)

    // {
    //   onSuccess: () => refetchLeads(),
    // }
  );

  // Return the query results and helper functions.
  return {
    saveErrorLogs,
    isLogsLoading,
  };
}
